import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { RotateCcw, Square } from "lucide-react";

const since = (iso) => { const m = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000)); return `${Math.floor(m / 60)}j ${String(m % 60).padStart(2, "0")}m`; };

export const ReworkBtn = ({ woId, stage }) => {
  const [d, setD] = useState(null); const [, tick] = useState(0);
  const load = () => api.get(`/workorders/${woId}/stages/${stage}/rework`).then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { if (woId) load(); }, [woId, stage]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 30000); return () => clearInterval(t); }, []);
  if (!d) return null;
  const act = d.logs.find((x) => !x.end);
  const go = async (action) => {
    const note = action === "start" ? window.prompt("Alasan rework / pekerjaan ulang:") : "";
    if (action === "start" && !note) return;
    try { const { data } = await api.post(`/workorders/${woId}/stages/${stage}/rework`, { action, note }); setD(data); toast.success(action === "start" ? "Rework dimulai — waktu berjalan dihitung" : "Rework selesai"); } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 text-[11px]" data-testid={`rework-${woId}-${stage}`}>
      {act ? <>
        <span className="px-2 py-0.5 rounded-full bg-rose-100 text-rose-700 font-semibold animate-pulse" data-testid={`rework-active-${woId}-${stage}`}>REWORK berjalan {since(act.start)} · {act.note}</span>
        <button type="button" data-testid={`rework-stop-${woId}-${stage}`} onClick={() => go("stop")} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-rose-300 text-rose-700"><Square className="w-3 h-3" />Selesai rework</button>
      </> : <button type="button" data-testid={`rework-start-${woId}-${stage}`} onClick={() => go("start")} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-slate-300 text-slate-600 hover:border-rose-300 hover:text-rose-600"><RotateCcw className="w-3 h-3" />Tandai rework</button>}
      {d.rework_minutes > 0 && <span className="text-slate-500">Total rework {Math.round(d.rework_minutes)} mnt ({d.logs.filter((x) => x.end).length}x)</span>}
    </div>
  );
};
